/**
 * @name isNumberOrString
 * @description Проверяет является переданная переменная числом или строкой. Нужно для проверки productId
 * @param data: any
 * @returns {boolean}
 */
export const isNumberOrString = (data: unknown) => typeof data === 'string' || typeof data === 'number';

/**
 * @name prepareProductPrice
 * @description Возвращает число из строки (productPrice)
 * @param productPrice: string
 * @returns {number}
 * @example "6 557,55" => 6557.55
 */
export const prepareProductPrice = (productPrice: string) =>
  parseFloat(productPrice.replace(/\s/g, '').replace(/,/g, '.'));

/**
 * @name isNumbers
 * @description Проверяет все ли аргументы число
 * @param args
 * @returns {boolean}
 */
export const isNumbers = (...args: unknown[]) => args.every(i => typeof i === 'number');

/**
 * @name isStrings
 * @description Проверяет все ли аргументы строки
 * @param args
 * @returns {boolean}
 */
export const isStrings = (...args: unknown[]) => args.every(i => typeof i === 'string');

/**
 * @name dyLoaded
 * @description Возвращает промис. Resolve вызовется, когда DY появилтся в глобальной области видимости.
 *  Промис ститает попытки. Попытка обнаружить DY происходит каждую секунду, всего 10 раз. Если будет 10 неудачных
 *  попыток то промис вернёт Reject.
 */
export const dyLoaded = () => {
  const max = 10;
  let attempt = 1;
  let interval: NodeJS.Timeout;
  return new Promise((resolve, reject) => {
    interval = setInterval(() => {
      if ('SL' in window) {
        clearInterval(interval);
        resolve(true);
      } else if (attempt === max) {
        clearInterval(interval);
        reject(new Error('DY not loaded'));
      }

      attempt += 1;
    }, 1000);
  });
};
